// extracted by mini-css-extract-plugin
export default {"btn":"LinkReports_btn__msS2i","svg":"LinkReports_svg__4Z0ts"};